import React from 'react'
import '../css/footer.css'

export default function Footer() {
    return <div className="footer">
        EIKO® LLC 2021 | All rights reserved.
    </div>
}